export const REFERRAL_COOKIE_NAME = "sv_ref_code";

const REFERRAL_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;

function normalizeReferralCode(code: string | null | undefined): string | null {
  const normalized = code?.trim();
  return normalized ? normalized : null;
}

export function writePendingReferralCode(code: string): void {
  if (typeof document === "undefined") return;
  const normalized = normalizeReferralCode(code);
  if (!normalized) return;

  document.cookie = `${REFERRAL_COOKIE_NAME}=${encodeURIComponent(
    normalized,
  )}; Max-Age=${REFERRAL_COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax`;
}

export function readPendingReferralCode(): string | null {
  if (typeof document === "undefined") return null;

  const cookie = document.cookie
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${REFERRAL_COOKIE_NAME}=`));

  if (!cookie) return null;

  const value = cookie.slice(REFERRAL_COOKIE_NAME.length + 1);
  try {
    return normalizeReferralCode(decodeURIComponent(value));
  } catch {
    return null;
  }
}

export function clearPendingReferralCode(): void {
  if (typeof document === "undefined") return;
  document.cookie = `${REFERRAL_COOKIE_NAME}=; Max-Age=0; Path=/; SameSite=Lax`;
}
